module.exports = __webpack_public_path__ + "img/ribao.29051b05.png";